<h1 class="confirmation-message-heading" mat-dialog-title>{{ data.header }}</h1>
<mat-dialog-content class="mat-dialog-content-no-heading">
  <div class="confirmation-dialog-message">
    {{ data.message }}
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  @if (data.dialogType === dialogTypes.Ok) {
    <button type="button" mat-raised-button color="primary" (click)="onOkClick()">OK</button>
  } @else {
    <button
      type="button"
      mat-raised-button
      color="primary"
      (click)="onYesClick()"
      id="25d0fb7b-702f-40aa-87f0-8c6798784800"
      >Yes</button
      >
      <button type="button" mat-stroked-button color="primary" (click)="onNoClick()">No</button>
    }
  </mat-dialog-actions>
